import { Alert, Button, Form } from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import React from 'react'
import Dragger from 'antd/es/upload/Dragger'
import { useImportRubricMutation } from '../../../../../../store/apis/rubric.api'
import { useDispatch } from 'react-redux'
import { rubricPersistActions } from '../../../../../../store/slices/rubric.persist.slice'
import { useParams } from 'react-router'

const ImportFileStep = () => {
    const { token } = useParams()

    const dispatch = useDispatch()

    const [importRubric, importRubricResult] = useImportRubricMutation()

    const handleSubmit = async values => {
        const importRubricResponse = await importRubric({ file: values.file })
        if ('data' in importRubricResponse) {
            dispatch(
                rubricPersistActions.setUnmatchedValuesPerQuestion({
                    token,
                    unmatchedValuesPerQuestion: importRubricResponse.data,
                }),
            )
            dispatch(rubricPersistActions.nextStep({ token }))
        }
    }

    const draggerProps = {
        name: 'file',
        accept: '.pdf, .doc, .docx',
        multiple: false,
        listType: 'picture',
        maxCount: 1,
        beforeUpload: () => false,
        height: 400,
    }
    return (
        <Form autoComplete='off' onFinish={handleSubmit} layout='vertical'>
            <Form.Item
                name='file'
                label='Rubric file'
                getValueFromEvent={event => event.file}
                rules={[{ required: true, message: 'Please, attach a rubric file' }]}
            >
                <Dragger {...draggerProps} aria-label='Rubric files'>
                    <p className='ant-upload-drag-icon'>
                        <InboxOutlined />
                    </p>
                    <p className='ant-upload-text'>Click or drag grading rubric file to this area</p>
                    <p className='ant-upload-hint'>Acceptable file formats: .pdf, .doc, .docx</p>
                </Dragger>
            </Form.Item>
            {importRubricResult.isError && <Alert message={importRubricResult?.error} type='error' showIcon closable />}
            <div className='d-flex-end'>
                <Form.Item className='mb-0'>
                    <Button type='primary' htmlType='submit' block loading={importRubricResult.isLoading}>
                        Process
                    </Button>
                </Form.Item>
            </div>
        </Form>
    )
}

export default ImportFileStep
